import {
    Theme,
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    accordionSummaryClasses,
    accordionClasses,
} from '@mui/material';

export const CaroteneAccordion: {
    defaultProps?: ComponentsProps['CaroteneAccordion'];
    styleOverrides?: ComponentsOverrides<Theme>['CaroteneAccordion'];
    variants?: ComponentsVariants['CaroteneAccordion'];
} = {
    defaultProps: {
        size: 'medium',
    },
    variants: [
        {
            props: { size: 'large' },
            style: {
                [`.${accordionClasses.root}:first-of-type`]: {
                    [`.${accordionSummaryClasses.root}`]: {
                        paddingTop: '1.5rem',
                    },
                },
                [`:not(.${accordionClasses.root}:first-of-type)`]: {
                    [`.${accordionSummaryClasses.root}`]: {
                        paddingTop: '4.5rem',
                    },
                },
            },
        },
    ],
};

export const MuiAccordion: {
    defaultProps?: ComponentsProps['MuiAccordion'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiAccordion'];
    variants?: ComponentsVariants<Theme>['MuiAccordion'];
} = {
    defaultProps: {
        elevation: 0,
    },
    styleOverrides: {
        root: (props) => ({
            color: props.theme.palette.text.secondary,
            backgroundColor: 'transparent',
            [`&.${accordionClasses.disabled}`]: {
                backgroundColor: 'transparent',
            },

            [`&.${accordionClasses.expanded}`]: {
                marginTop: '0',
                '::before': {
                    opacity: 1,
                },
                '& + &': {
                    // When two expanded accordions are next to each other
                    '::before': {
                        display: 'block',
                    },
                },
            },
        }),
    },
};

export const MuiAccordionSummary: {
    defaultProps?: ComponentsProps['MuiAccordionSummary'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiAccordionSummary'];
    variants?: ComponentsVariants['MuiAccordionSummary'];
} = {
    styleOverrides: {
        root: (props) => ({
            color: 'inherit',
            padding: props.theme.spacing(props.theme.tokens.spacing.none),
            [`&.${accordionSummaryClasses.focusVisible},&:hover`]: {
                color: props.theme.palette.text.primary,
                background: 'unset',
            },
            [`&.${accordionSummaryClasses.expanded}, &`]: {
                minHeight: 64,
            },
            [`&.${accordionSummaryClasses.disabled}`]: {
                opacity: 'unset',
                [`.${accordionSummaryClasses.expandIconWrapper}`]: {
                    visibility: 'hidden',
                },
            },
        }),
        content: (props) => ({
            margin: props.theme.spacing(props.theme.tokens.spacing.md, props.theme.tokens.spacing.none),
            [`&.${accordionSummaryClasses.expanded}`]: {
                margin: props.theme.spacing(props.theme.tokens.spacing.md, props.theme.tokens.spacing.none),
            },
        }),
        expandIconWrapper: {
            color: 'inherit',
        },
    },
};
export const MuiAccordionDetails: {
    defaultProps?: ComponentsProps['MuiAccordionDetails'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiAccordionDetails'];
    variants?: ComponentsVariants['MuiAccordionDetails'];
} = {
    styleOverrides: {
        root: (props) => ({
            padding: props.theme.spacing(props.theme.tokens.spacing.none),
            backgroundColor: 'transparent',
        }),
    },
};
